import { ITEMS_PER_PAGE_OPTIONS } from '@constants/pagination/pagination.constant';
import { PaginatePipeArgs } from 'ngx-pagination';

export class PaginateControlSettings implements PaginatePipeArgs {
  id: string;
  itemsPerPage: number;
  currentPage: number;
  totalItems: number;

  constructor(value?: PaginatePipeArgs) {
    this.id = value?.id || '';
    this.itemsPerPage = value?.itemsPerPage as number || ITEMS_PER_PAGE_OPTIONS[0];
    this.currentPage = value?.currentPage as number || 1;
    this.totalItems = value?.totalItems as number || 0;
  }
}
